var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3811 5.57141H6.80969C6.15296 5.57141 5.52313 5.83229 5.05876 6.29667C4.59438 6.76105 4.3335 7.39087 4.3335 8.0476V19.1905C4.3335 19.8472 4.59438 20.477 5.05876 20.9414C5.52313 21.4058 6.15296 21.6666 6.80969 21.6666H19.1906C19.8474 21.6666 20.4772 21.4058 20.9416 20.9414C21.4059 20.477 21.6668 19.8472 21.6668 19.1905V13.619",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6666 4.29249C21.9967 4.63378 22.1794 5.09109 22.1755 5.56585C22.1715 6.04061 21.9812 6.49482 21.6456 6.83059L12.9999 15.4762L9.28564 16.7143L10.5237 13L19.1743 4.2764C19.4784 3.96994 19.8854 3.78715 20.3165 3.76336C20.7476 3.73958 21.1721 3.8765 21.5081 4.14764L21.6666 4.29249Z",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1904 6.80951L20.3703 8.0476",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/create-icon.71e1338aef7ebf00a1da889dd5f6e4c9.svg";
export { ForwardRef as ReactComponent };